import React from 'react'
import { Container } from '../Container'
import styles from './LoadingAnimation.module.css'

export const EzosLoader = () => {
    return (
        <Container
            style={{
                padding: '20px 0',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
            }}
        >
            <div className={styles.ezosloader}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </Container>
    )
}
